import { Component, HostBinding, inject, input, output } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { QaiButtonComponent, QaiCallButtonComponent, QaiCallTimerComponent, QaiIconComponent } from '@qai/ui';
import { NativeCallService } from 'src/app/services/native-call.service';

@Component({
  imports: [
    QaiCallButtonComponent,
    QaiCallTimerComponent,
    TranslocoModule,
    QaiIconComponent,
    QaiButtonComponent
  ],
  selector: 'app-call-footer',
  standalone: true,
  styleUrls: ['./call-footer.css'],
  templateUrl: './call-footer.html',
})
export class CallFooterComponent {
  private readonly nativeCallService = inject(NativeCallService);

  @HostBinding('class.native-ios')
  protected get isNativeIos() {
    return this.nativeCallService.isNativeIos;
  }

  isCaptionsOn = input.required<boolean>();
  time = input.required<string>();
  isPaused = input.required<boolean>();
  showPauseButton = input.required<boolean>();
  isPauseEnabled = input.required<boolean>();
  isRealTimeCall = input.required<boolean>();
  showContinueButton = input.required<boolean>();

  readonly settingsClicked = output();
  readonly captionsClicked = output();
  readonly playbackClicked = output();

  protected handleSettingsClick() {
    this.settingsClicked.emit();
  }

  protected handleCaptionsClick() {
    this.captionsClicked.emit();
  }

  protected handlePlaybackClick() {
    this.playbackClicked.emit();
  }
}
